module.exports = __webpack_public_path__ + "static/media/student-reading-male-caucasian.7373020c.png";